import { formatDateLong, useQuery } from '@threatadvisor/react-utils';
import { createStyles } from 'antd-style';
import React, { ReactElement } from 'react';

const useStyles = createStyles({
  reporttitlepage: {
    '@page': {
      marginTop: 0 /* Adjust the margin size as needed */,
      marginBottom: 0,
      marginLeft: '0in',
      marginRight: '0in'
    },

    ['position' as never]: 'relative',
    height: '10.7in',
    width: '8.5in',
    top: 0,
    left: 0,
    size: 'letter',
    '@media screen': {
      boxShadow: '0 0 10px 10px rgba(0,0,0,.1)'
    },

    '#blackRectangle': {
      ['position' as never]: 'absolute',
      backgroundColor: 'black',
      width: '6.355in',
      height: '6.96in',
      left: '0',
      top: '0'
    },
    '> div': {
      ['position' as never]: 'absolute',
      padding: '0.75in',
      width: '6.355in',
      height: '6.96in',
      left: '0',
      top: '0',
      '#logoSmall': {
        width: '250px',
        marginBottom: '70px'
      }
    },
    '> #logoLarge': {
      width: '4.4577in',
      ['position' as never]: 'absolute',
      left: '4.12in',
      bottom: '0',
      opacity: '0.4'
    },
    'h1, h2, h3, h4': {
      color: '#f5f5f9',
      marginTop: '15px'
    },
    a: {
      color: '#f5f5f9'
    },
    'h1, h2, h3': {
      fontWeight: 600,
      ['textTransform' as never]: 'uppercase'
    }
  }
});

export default function TitlePage({
  clientName,
  title,
  subtitle,
  dateTitle
}: {
  clientName: string;
  title: string;
  subtitle: string | undefined;
  dateTitle: string;
}): ReactElement | null {
  const search = useQuery();
  const applyWhiteLabel = search.get('whitelabel') === 'true';

  const { cx, styles } = useStyles();
  return (
    <div className={cx(styles.reporttitlepage)} id="reporttitlepage">
      <div id="blackRectangle"></div>
      <img id="logoLarge" src="/shield.png" alt="" />
      <div>
        <img id="logoSmall" src={applyWhiteLabel ? '/talogo.png' : '/ddlogo.png'} alt="" />

        <h2>{clientName}</h2>
        <h3>{title}</h3>
        {subtitle && <h3>{subtitle}</h3>}
        {dateTitle && <h3>{dateTitle}</h3>}

        <h4 style={{ marginTop: 70 }}>
          Compiled by
          <br />
          ThreatAdvisor&trade;
          <br />
          <a href="http://www.threatadvisor.com" target="_blank" rel="noopener noreferrer">
            www.threatadvisor.com
          </a>
          <br />
          {formatDateLong(new Date())}
        </h4>
      </div>
    </div>
  );
}
